/**
 * SubNav — pill/underline tabs of the sibling routes in the active nav group
 * (ported from vanilla renderSubNav). Lets a group's tabs (incl. its guide) be
 * reachable from any page in that group. Hidden when the group has ≤1 tab.
 */
import { Link, useLocation } from 'react-router-dom';
import { findNavGroup } from '../nav/config';

export function SubNav() {
  const location = useLocation();
  const id = location.pathname.replace(/^\/+/, '').split('/')[0] ?? '';
  const found = findNavGroup(id);
  if (!found) return null;
  const tabs = found.group.tabs;
  if (tabs.length <= 1) return null;

  return (
    <div className="flex gap-1 border-b border-gray-200 mb-4 -mt-2 overflow-x-auto">
      {tabs.map((t) => {
        const on = t.id === id;
        return (
          <Link
            key={t.id}
            to={`/${t.id}`}
            className={`px-4 py-2.5 text-sm border-b-2 whitespace-nowrap transition ${
              on ? 'font-medium border-brand-600 text-brand-600' : 'text-gray-500 border-transparent hover:text-gray-700'
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
